import { Document } from '@tiptap/extension-document';
import { Text } from '@tiptap/extension-text';
import { History } from '@tiptap/extension-history';
import { Dropcursor } from '@tiptap/extension-dropcursor';
import { Gapcursor } from '@tiptap/extension-gapcursor';
import { Color } from '@tiptap/extension-color';
import { FontFamily } from '@tiptap/extension-font-family';
import { HardBreak } from '@tiptap/extension-hard-break';

import { Table } from './table';
import { TableRow } from './table-row';
import { TableCell } from './table-cell';
import { TableHeader } from './table-header';
import { Heading } from './heading';
import { Code } from './code';
import { CodeBlock } from './code-block';
import { Link } from './link';
import { TextAlign } from './text-align';
import { FontSize } from './font-size';
import { Paragraph } from './paragraph';
import { Formatting } from './formatting';
import { TextStyle } from './text-style';
import { Blockquote } from './blockquote';
import { Bold } from './bold';
import { Italic } from './italic';
import { Underline } from './underline';
import { Strike } from './strike';
import { OrderedList } from './ordered-list';
import { BulletList } from './bullet-list';
import { ListItem } from './list-item';
import { Image } from './image';
import { HorizontalRule } from './horizontal-rule';
import { BubbleMenu } from './bubble-menu';

/**
 * @typedef {import('@tiptap/core').Extension} Extension
 * @typedef {import('@tiptap/extension-bubble-menu').BubbleMenuOptions} BubbleMenuOptions
 */

/**
 *
 * @param {{bubbleMenu: BubbleMenuOptions}} options
 * @return {Array<Node<any, any>|Extension<any,any>>}
 */
export function resolveExtensions(options) {
    return [
        Document,
        Text,
        History,
        Dropcursor,
        Gapcursor,
        Color,
        FontFamily,
        HardBreak,
        Table,
        TableRow,
        TableCell,
        TableHeader,
        Heading,
        Code,
        CodeBlock,
        Link,
        TextAlign,
        FontSize,
        Paragraph,
        Formatting,
        TextStyle,
        Blockquote,
        Bold,
        Italic,
        Underline,
        Strike,
        OrderedList,
        BulletList,
        ListItem,
        Image,
        HorizontalRule,
        BubbleMenu(options.bubbleMenu)
    ]
}
